module.exports = __webpack_public_path__ + "static/vf-button-women-bag.276a2152.svg";